import React from 'react';
import PropTypes from 'prop-types';
import { ImageMosaic, ImageMosaicDto, MosaicWall } from '@ami/react/core';
import { Alert } from 'reactstrap';
import { makeConcealable } from '@ami/react/core';

const AttachmentPointSelection = ({
  attachmentPoints,
  attachmentPointId,
  disabledAttachmentPointIds,
  onChange,
}) => {
  const mapped = attachmentPoints.map((x) => {
    var isDisabled =
      disabledAttachmentPointIds &&
      disabledAttachmentPointIds.find((a) => a === x.id);
    return new ImageMosaicDto({
      id: x.id,
      label: x.name,
      imageUrl: x.imageUrl,
      selected: x.id === attachmentPointId,
      padding: 'p-1',
      disabled: isDisabled,
      description: isDisabled ? (
        <em className="restricted-item">
          <i className="fa fa-exclamation-circle"></i> Not available for
          selected lugging
        </em>
      ) : null,
    });
  });
  return (
    <div className="row my-4">
      <MosaicWall
        title="Select Attachment Point"
        childrenContainerClassName="row justify-content-center"
      >
        {mapped.map((x) => (
          <ImageMosaic
            key={x.id}
            data={x}
            disabled={x.disabled}
            onClick={() => onChange(x.id)}
          />
        ))}
        {mapped.length === 0 && (
          <Alert color="warning" className="text-center">
            <i className="fa fa-exclamation-circle fa-lg text-danger" /> No
            attachments were found for the selected carrier
          </Alert>
        )}
      </MosaicWall>
    </div>
  );
};

AttachmentPointSelection.propTypes = {
  onChange: PropTypes.func.isRequired,
  attachmentPointId: PropTypes.string,
  attachmentPoints: PropTypes.arrayOf(Object),
  disabledAttachmentPointIds: PropTypes.array,
};

const AttachmentPointSelectionComponent = makeConcealable(
  AttachmentPointSelection
);
export { AttachmentPointSelectionComponent };
